import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import Mousetrap from "mousetrap";
import { get, isEmpty, size, filter, cloneDeep, forEach } from "lodash";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import SiteLogTable from "./SiteLogTable";
import Loader from "../Common/Loader";
import Error from "../Common/Error";

import { fetchLogs } from "../../utils/eventGroups";
import { driveInOut, walkInOut, trainInOut } from "../../constants/reducers";
import { LOG_EVENT_GROUP_TYPES } from "../../constants/logEventGroupTypes";

import colors from "../../assets/style/colors";

const styles = {
  tableContainer: {
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    borderRadius: "4px",
    backgroundColor: colors.white,
  },
};

const displayColumns = {
  driveInOut: {
    0: [0, 1, 2, 3],
    1: [0, 1],
    2: [0, 1, 2],
    3: [0, 1],
    4: [0, 1],
    5: [0, 1],
    6: [0, 1],
    7: [0, 1],
  },
  walkInOut: {
    0: [0, 1, 2],
    1: [0, 1, 2, 3, 4, 5, 6],
    2: [0, 1],
  },
};

const SiteHistory = (props) => {
  const { classes, logs, section } = props;
  const logTypes = get(LOG_EVENT_GROUP_TYPES, section);

  React.useEffect(() => {
    if (props.powerUserMode) {
      Mousetrap.bind("ctrl+1", () => {
        loadMore(10);
        return false;
      });
      Mousetrap.bind("ctrl+2", () => {
        loadMore(20);
        return false;
      });
      Mousetrap.bind("ctrl+3", () => {
        loadMore(30);
        return false;
      });
      Mousetrap.bind("ctrl+4", () => {
        loadMore(40);
        return false;
      });
      Mousetrap.bind("ctrl+5", () => {
        loadMore(50);
        return false;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.powerUserMode, props.logs.offset]);

  React.useEffect(() => {
    if (/*!logs.logs &&*/ !logs.isFetching) {
      if (logs.logs) {
        fetchLogs(
          props.dispatch,
          section,
          props.tabIndex,
          [props.zone.id],
          logTypes,
          logs.logs.length,
          0,
          true
        );
      } else {
        fetchLogs(
          props.dispatch,
          section,
          props.tabIndex,
          [props.zone.id],
          logTypes,
          10,
          0
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.zone]);

  const loadMore = (limit = 10) => {
    fetchLogs(
      props.dispatch,
      section,
      props.tabIndex,
      [props.zone.id],
      logTypes,
      limit,
      props.logs.offset,
      true
    );
  };

  const getDisplayColumns = () => {
    let columns = cloneDeep(displayColumns[section]);
    if (section === driveInOut) {
      const colIdMap = {
        trailer1: 3,
        trailer2: 4,
        container1: 5,
        container2: 6,
      };
      forEach(colIdMap, (v, k) => {
        if (
          size(
            filter(get(logs, ["logs"]), (item) => !isEmpty(get(item, [k])))
          ) === 0
        ) {
          delete columns[v];
        }
      });
    }
    return columns;
  };

  return (
    <Box>
      <Grid container style={{ marginBottom: "10px" }} justify="center">
        <Grid item xs={3} style={{ paddingTop: "2px" }}>
          <hr style={{ borderLeft: "none" }} />
        </Grid>
        <Grid item>
          <span
            className="text-87"
            style={{
              textAlign: "center",
              textTransform: "uppercase",
              fontWeight: "500",
              padding: "0px 20px",
            }}
          >
            {props.zone.name + " " + I18n.get("site_historic")}
          </span>
        </Grid>
        <Grid item xs={3} style={{ paddingTop: "2px" }}>
          <hr style={{ borderLeft: "none" }} />
        </Grid>
      </Grid>

      {!props.zone ? (
        <Error
          height={section === walkInOut ? "280px" : "340px"}
          error={I18n.get("site_pleaseSelectZone")}
        />
      ) : logs.error ? (
        <Error
          height={section === walkInOut ? "280px" : "340px"}
          error={logs.error}
        />
      ) : !logs.logs ? (
        <Loader height={section === walkInOut ? "280px" : "340px"} />
      ) : (
        <Box className={classes.tableContainer}>
          <SiteLogTable
            section={section}
            tabIndex={props.tabIndex}
            openedTabsNb={props.openedTabsNb}
            logs={logs.logs.filter(
              (item) => get(item, ["complete", "active"]) === true
            )}
            sort={logs.sort}
            short={true}
            displayNb={5}
            displayColumns={getDisplayColumns()}
            totalRows={logs.total || 0}
            loadMore={logs.logs.length < logs.total ? loadMore : undefined}
            isFetching={logs.isFetching}
            open={logs.collapsed}
            rowsPerPage={100000000}
          />
        </Box>
      )}
    </Box>
  );
};

SiteHistory.propTypes = {
  logs: PropTypes.object,
  zone: PropTypes.object.isRequired,
  tabIndex: PropTypes.number,
};

export default connect()(withStyles(styles)(SiteHistory));
